// Making a new JS component
// 1 - Replace validation with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var validation = {
	name: 'validation',
	componentInitSelector: '.validationMe',
	registerComponent: function() {
		if ( $(validation.componentInitSelector).length ) {
			framework.registerComponent(validation);
		}
	},
	captchaCallback: function() {
		$('.captcha-container').each(function(index) {
			var $elem = $(this);
			var $form = $elem.closest('form');

			// generate an id
			if (!$elem.attr('id')) {
				$elem.attr('id', 'captcha-container-' + index);
			}

			$form.find('input,textarea').focus(function() {
				if ($form.data('captcha-init')) {
					// already initialized
					return;
				}
				$form.data('captcha-init', true);

				var captchaId = grecaptcha.render($elem.attr('id'), {
					'sitekey' : $elem.data('sitekey'),
					'callback' : function(token) {
						var captchaId = $form.data('captcha-id');
						if (grecaptcha.getResponse(captchaId)) {
							$form[0].submit();
						} else {
							alert($form.data('captcha-error-msg') || 'Please confirm captcha to proceed');
						}
					}
				});
				
				$form.data('captcha-id', captchaId);
			});
		});
	},
	initvalidation: function() {
		// Put your args and inits here with their options.
		var $forms = $("form.standard");
        $forms.each(function () {
			var $form = $(this);
			if ($form.hasClass('captcha-enabled')) {
				$form.validate({
					submitHandler: function(form) {
						var captchaId = $form.data('captcha-id');
						grecaptcha.execute(captchaId);
					}
				});
			} else {
				$form.validate();
			}
		});
		
		if ($forms.filter('.captcha-enabled').length > 0) {
			loadScript("https://www.google.com/recaptcha/api.js?onload=captchaCallback&render=explicit");
		}


		// Field is not empty, to keep label above input
		$('form.standard input').blur(function()
		{
		    if( $(this).val().length === 0 ) {
		          $(this).addClass('not-empty');
		    }
		});


		
        // End
        log(config.application.name + " •• validation in " + Math.round( performance.now() - framework.initComponents.componentInitTime) + " milliseconds" );
    },
	init: function() {
		// All code for this component goes in here

		// End
		validation.initvalidation();
	}
}

// Register self to the framework
validation.registerComponent();

// has to be global
function captchaCallback() {
	validation.captchaCallback();
}